



<div class="table-view busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
      <div>{{errorMsg}}</div>
      <div class="">
          <i class="fa fa-times" role="button" (click)="errorMsg=null"></i>
      </div>
    </div>

    <div class="table-view-header-controls" style="position:sticky;left:0;">
    <div class="d-flex flex-wrap">
      <div class="px-2" style="font-size:18px;font-weight: bold;">
        Building Points
      </div>
      <div class="d-flex flex-row">
        <ng-template #configModal>
          <div class="m-0 p-1 modal-header font-weight-bold" style="background-color: #CFD5EA;">
            Table Options
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfigModal(configComponent)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <fes-table-view-config #configComponent [table]="this" [pagingEnabled]="false"
                (filterKeyUp)="$event.event.key=='Enter'&&closeConfigModal(configComponent)">
            </fes-table-view-config>
          </div>
          <div class="m-0 p-1 modal-footer d-flex flex-row justify-content-between">
            <div></div>
            <button class="btn btn-warning" (click)="closeConfigModal(configComponent)">Close</button>
          </div>
        </ng-template>
        <div class="pl-2 my-auto small">
          <a href="javascript:false;" (click)="showConfigModal(configModal)">
            <i class="fa fa-columns px-sm-1"></i>
          </a>&nbsp;
          <!-- should update automatically
          <a href="javascript:false;" (click)="!isLoading&&load()" [ngStyle]="{'opacity':isLoading?'0.2':'1'}">
            <i class="fa fa-redo px-sm-1"></i>
          </a>
          -->
          <a href="javascript:false;" (click)="!bDownloading&&download()" [ngStyle]="{'opacity':bDownloading?'0.2':'1'}">
            <i [ngClass]="'fa fa-download' + (bDownloading?' blink':'')"></i>
          </a>
        </div>
      </div>

    </div>
    </div>



    <div class="p-2 table-view-table-wrapper">
      <table class="table-view-table table">
        <thead>
          <tr>
            <th *ngFor="let column of visibleColumns; index as visibleIndex;" role="button"
              class="p-0 align-bottom" [ngClass]="column.headerCellCssClass">
              <div class="d-flex flex-row justify-content-between">
                <div class="w-100 py-sm-1 text-center" (click)="column.name&&sort(column.name)">{{column.title}}</div>
                <div class="d-flex flex-column justify-content-end">
                  <app-table-dropdown-filter [sortKey]="sortColumns[0]?.key" [column]="column" [visibleIndex]="visibleIndex"
                  [bSortAscending]="sortColumns[0]?.order=='ASC'" (closed)="reload()">
                  </app-table-dropdown-filter>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let record of records;index as index;">
            <tr [ngClass]="record.point&&record.point.id==selectedRecord?.point?.id?'selected':''" (click)="selectedRecord=record">
            <ng-container *ngFor="let column of visibleColumns;">
              <td [ngSwitch]="column.template"
                (dblclick)="onDataCellDblClick(column,record)" role="button"
                [ngClass]="column.dataCellCssClass + (column.template=='type'? ' point-type-' + record['point.type']:'')">
                <div *ngSwitchCase="'percent'" [ngClass]="{'text-super-muted':record[column.name]==0}">{{record[column.name]|percent:'.0-2'}}</div>
                <div *ngSwitchCase="'numeric'" [ngClass]="record[column.name]==0?'text-super-muted':'text-blue'">{{(record[column.name]|number:'0.4')||'-'}}</div>
                <div *ngSwitchCase="'text'">{{record[column.name]}}</div>
                <div *ngSwitchCase="'type'">{{record[column.name]}}</div>
                <div *ngSwitchCase="'scoutPointBtn'" role="button" (dblclick)="showScoutPoint(record.path,record.point)">{{record[column.name]}}</div>
                <div *ngSwitchCase="'latLngNumber'">{{record[column.name]?.toFixed(7)}}</div>
                <div *ngSwitchCase="'nearestWindowDistance'">
                  <ng-container *ngIf="!record[column.name]; else asMeters">
                    0
                  </ng-container>
                  <ng-template #asMeters>
                    {{record[column.name]?.toFixed(2)}} M
                  </ng-template>
                </div>
                <div *ngSwitchCase="'empty'"></div>
                <ng-container *ngSwitchDefault>{{record[column.name]}}</ng-container>
              </td>
            </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div *ngIf="!isLoading&&records.length==0" class="pt-2 text-center text-warning">
        No Building Points Found.
      </div>
    </div>

  </div>

